import { configureStore } from '@reduxjs/toolkit';
import { TCreateStoreFunctionSignature } from '../../common/redux';
import { createSubsidizedCalculatorApi } from '../api';
import { subsidizedCalculatorSlice } from './subsidizedCalculatorSlice';

export const createSubsidizedCalculatorStore = ((context, preloadedState, devTools) => {
  const subsidizedCalculatorApi = createSubsidizedCalculatorApi(context);

  return configureStore({
    reducer: {
      [subsidizedCalculatorApi.reducerPath]: subsidizedCalculatorApi.reducer,
      [subsidizedCalculatorSlice.name]: subsidizedCalculatorSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ thunk: { extraArgument: context } }).concat(subsidizedCalculatorApi.middleware),
    preloadedState,
    devTools,
  });
}) satisfies TCreateStoreFunctionSignature;
